import React, {useState} from "react";
import {Copy, Check} from "lucide-react";

const ResourceDownloadLink = ({url}) => {
  const [copied, setCopied] = useState(false);
  const [error, setError] = useState("");

  const copyLink = async () => {
    setError("");
    try {
      if (navigator.clipboard?.writeText) {
        await navigator.clipboard.writeText(url);
      } else {
        const input = document.createElement("textarea");
        input.value = url;
        input.setAttribute("readonly", "");
        input.style.position = "fixed";
        input.style.opacity = "0";
        document.body.appendChild(input);
        input.select();
        const copiedToClipboard = document.execCommand("copy");
        document.body.removeChild(input);
        if (!copiedToClipboard) throw new Error("Clipboard access is unavailable.");
      }
      setCopied(true);
      window.setTimeout(() => setCopied(false), 2000);
    } catch {
      setError("Could not copy the download link. Select and copy it manually.");
    }
  };

  if (!url) return <span className="text-sm text-stone-400">No file link available.</span>;

  return (
    <div className="min-w-0">
      <div className="flex flex-wrap items-center gap-2">
        <a
          href={url}
          target="_blank"
          rel="noreferrer"
          className="max-w-full truncate text-sm font-medium text-blue-700 underline decoration-blue-200 underline-offset-2 hover:text-blue-900"
          title={url}
        >
          Open download link
        </a>
        <button
          type="button"
          onClick={copyLink}
          className="inline-flex shrink-0 items-center gap-1 rounded-lg border border-blue-100 px-2.5 py-1.5 text-xs font-semibold text-blue-700 transition hover:bg-blue-50"
        >
          {copied ? <Check className="h-3.5 w-3.5" /> : <Copy className="h-3.5 w-3.5" />}
          {copied ? "Copied" : "Copy link"}
        </button>
      </div>
      {error ? <p className="mb-0 mt-1 text-xs text-red-600">{error}</p> : null}
    </div>
  );
};

export default ResourceDownloadLink;
